// Resolve JWT for regular (localStorage) and partner (sessionStorage) sessions.
export function getAuthToken() {
  const sessionTok = sessionStorage.getItem('auth_token');
  if (sessionTok) return sessionTok;
  try {
    const raw = localStorage.getItem('token');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
